import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="16" height="16" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}><path stroke="#FFF" strokeWidth="2" d="M12 0L4 8l8 8" fill="none" fillRule="evenodd" /></svg>);